'use strict';

// Angular

var wbApp = angular.module('wbApp', [
    'ngAnimate',
    'mgcrea.ngStrap',
    'pascalprecht.translate',
    'ngResource',
    'ngSanitize',
    'wb.directives',
    'angulartics',
    //'angulartics.google.analytics',
    'angulartics.facebook.pixel',
    'LocalStorageModule',
    'uiGmapgoogle-maps',
    'googlechart',
    'WBGrid',
    'nemLogging',
    'jkuri.gallery',
    'angular-lightbox',
    'dx'
]);

//wbApp.config(['$tabProvider', function ($tabProvider) {
//    angular.extend($tabProvider.defaults, {
//        template: 'details-tabs-template.html'
//    });
//}]);

wbApp.config(['$locationProvider', function ($locationProvider) {
    $locationProvider.html5Mode({ enabled: true, requireBase: false, rewriteLinks: false });
}]);

wbApp.config(['$modalProvider', function ($modalProvider) {
    angular.extend($modalProvider.defaults, {
        animation: 'am-fade-and-slide-top',
        placement: 'center',
        backdrop: 'static',
    });
}]);

wbApp.config(['$datepickerProvider', function ($datepickerProvider) {
    angular.extend($datepickerProvider.defaults, {
        startWeek: 1,
        autoclose: true,
        container: 'body',
        useNative: true,
        dateFormat: 'd.M.yyyy'
    });
}]);

wbApp.config(['$timepickerProvider', function ($timepicketProvider) {
    angular.extend($timepicketProvider.defaults, {
        autoclose: true,
        //container: 'body',
        useNative: true,
        timeFormat: 'H:mm'
    });
}]);

wbApp.config(['localStorageServiceProvider', function (localStorageServiceProvider) {
    localStorageServiceProvider.setPrefix('wbAppNgAdmin');
    localStorageServiceProvider.setStorageType('localStorage');
    localStorageServiceProvider.setNotify(true, true);
}]);

function convertDateStringsToDates(input) {
    // Ignore things that aren't objects.
    if (typeof input !== "object") return input;

    for (var key in input) {
        if (!input.hasOwnProperty(key)) continue;

        var value = input[key];
        var match;
        // Check for string properties which look like dates.
        if (typeof value === "string" && isNaN(value)) {
            var date = moment(value, moment.ISO_8601);
            if (date.isValid()) {
                input[key] = date.toDate();
            }
        } else if (typeof value === "object") {
            // Recurse into object
            convertDateStringsToDates(value);
        }
    }
}

//var regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(Z|([\-+])(\d{2}):(\d{2}))?)?)?)?$/;
//var regexIso8601 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|([\-+])(\d{2}):(\d{2}))?$/;

wbApp.config(["$httpProvider", function ($httpProvider) {
    $httpProvider.defaults.transformResponse.push(function (data, headerGetter) {
        convertDateStringsToDates(data);
        return data;
    });

    $httpProvider.defaults.transformRequest.push(function (data, header) {
        return data;
    });
}]);

wbApp.config(['$translateProvider', function ($translateProvider) {
    $translateProvider
        .useSanitizeValueStrategy(null);
    $translateProvider
        .preferredLanguage(preferredLanguage);
    $translateProvider
        .use(preferredLanguage);    
}]);



// Strip the timezone
Date.prototype.toISOString = function () {
    return moment(this).format('YYYY-MM-DDTHH:mm:ss');
};

wbApp.constant('currentUser', loggedInUser);
wbApp.constant('preferredLanguage', preferredLanguage);
wbApp.constant('securityFeatures', securityFeatures);
wbApp.constant('tenantInfo', tenantInfo);

moment.locale(preferredLanguage);
moment.duration().locale(preferredLanguage);

if (tenantInfo.isFranchiseCentral) {
    wbApp.config(['uiGmapGoogleMapApiProvider', function (uiGmapGoogleMapApiProvider) {
        uiGmapGoogleMapApiProvider.configure({
            key: 'AIzaSyDgac1ahn5_WNYnb1b0TgRf7Q_JhM3ZRQc',
            v: '3.20', //defaults to latest 3.X anyhow
            libraries: 'weather,geometry,visualization'
        });
    }]);
}


